// extracted by mini-css-extract-plugin
export default {"table":"SettlementDetails_table__25Q11","action":"SettlementDetails_action__u-CO9","menuItemActive":"SettlementDetails_menuItemActive__KbyAG"};